import React, { useState, useEffect, useContext, useRef, useDebugValue } from 'react';

import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import FormPermissionService from "../../Setup/controller/FormPermissionController/FormPermissionController";
import PurchaseOrderService from "../Controller/PurchaseOrderController";
import PartService from "../../Parts/Controller/PartController";
import PurchaseOrderDetailModal from "./PurchaseOrderDetail";
import useFormSubmission from '../../Auth/Controller/AuthController';

import { SidebarContext } from '../../Layout/SidebarContext';
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import Common from '../../Common/Common';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../Common/HelpLink";
import SupplierService from "../../Supplier/Controller/SupplierController";
import CurrencyService from "../../Setup/controller/CurrencyController/CurrencyController";
import { convertCurrency } from "./PurchaseOrderForms/CurrencyConverter";
import PurchaseOrderDeliveryModal from "./PurchaseOrderForms/PurchaseOrderDelivery";
import useOrderPurchase from "./PurchaseOrderForms/useOrderPurchase";
import DeliverPurchase from "./PurchaseOrderForms/DeliverPurchase";
import ShortFallPartPage from './PurchaseOrderForms/ShortfallModal';
import { useTranslation } from 'react-i18next';
import ColumnOptionDropDown from "../../Lead/Views/LeadForms/ColumnOptionDropDown";
import Cookies from "js-cookie";
import { formatDateWithFns } from '../../Common/DateInputFormat';
import useDateFormat from '../../Common/fetchDateFormat';
import LockReleaseService from "../../Setup/controller/LockReleaseController/LockModuleController";
import CustomerService from "../../Customer/Controller/CustomerController";
import MultiSearchDropDown from "../../Common/MultiSearchDropDown";

import JasperReportService from '../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../config/axiosInstance';
import Draggable from 'react-draggable';
import ReportService from "../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../Setup/controller/TermsConditionController/TermsConditionController";
import BASE_URL from "../../../config/config";
import { PDFDocument } from "pdf-lib";
import CompanySetupController from "../../SuperAdmin/Controller/Client/SACompanyListController";
function PurchaseOrderList({ ClientCompanyID, SupplierID }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const tableRef = useRef();
  const FormAction = "/PurchasingList";
  //FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);

  const [modalInstance, setModalInstance] = useState(null);
  const { theme, toggleTheme } = useContext(ThemeContext);
  let accordTheme = "accordion-header-light";
  if (theme == "dark") {
    accordTheme = "accordion-header-dark";
  }
  const [PurchaseOrderList, setPurchaseOrderData] = useState([]);
  const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
  const [modalInstanceCustomerDetail, setModalInstanceCustomerDetail] = useState(null);
  const [shorFallPartList, setshorFallPartList] = useState([]);
  const [showPurchaseDeliveryModal, setshowPurchaseDeliveryModal] = useState(false);
  const [bnt_OrderNumber, set_bnt_OrderNumber] = useState("");
  const [CustomerID, set_CustomerID] = useState(0);
  const [jobID, set_JobID] = useState(0);
  const [purchaseID, set_PurchaseID] = useState("");
  const [selectedId, setSelectedId] = useState("0");
  const [loading, setLoading] = useState(true);
  const [isSFModalOpen, setIsSFModalOpen] = useState(false);
  const [partList, setPartData] = useState([]);
  const [SupplierList, setSupplierList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [searchQuery, setSearchQuery] = useState('');
  const [poCount, setPOCount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const CompanyID = localStorage.getItem("CompanyID");
  const UserID = localStorage.getItem("UserID");
  const [multipleIds, setMultipleIds] = useState([]);
  const activeDateFormat = useDateFormat();
  const [recentSearches, setRecentSearches] = useState([]);
  const setSortConfigInCookie = (config) => {
    Cookies.set(`PurchasingSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
  };
  const getSortConfigFromCookie = () => {
    const sortCookie = Cookies.get(`PurchasingSort_${CompanyID}_${UserID}`);
    return sortCookie ? JSON.parse(sortCookie) : { key: 'PK_PurchaseOrder_ID', direction: 'desc' };
  };
  const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());


  const setPageSizeInCookie = (pageSize) => {
    document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
  };
  const getPageSizeFromCookie = () => {
    const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
    return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
  };
  const [pageSize, setPageSize] = useState(getPageSizeFromCookie());

  const fetchPurchaseOrder = async (ClientCompanyID, SupplierID, page, size) => {
    try {

      setLoading(true);
      debugger;
      const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
      const PageSize = size.toString();
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const purchaseOrderData = await PurchaseOrderService.GetAllPurchaseOrders(redirectCallback, ClientCompanyID, SupplierID, Start.toString(), PageSize.toString(),
        searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns.toString());
      setPurchaseOrderData(purchaseOrderData);

      const porderCount = await PurchaseOrderService.GetPurchaseOrderCount(redirectCallback, CustomerID, SupplierID, searchQuery, searchColumns.toString());
      setPOCount(porderCount[0].TotalRecords);
      setTotalPages(Math.ceil(porderCount[0].TotalRecords / size));
    } catch (error) {
      console.error('Error fetching Teams:', error);
    } finally {
      setLoading(false); // Stop loading after fetching
    }
  };
  const fetchParts = async () => {
    try {
      const data = await PartService.ShortFallParts();
      setshorFallPartList(data);
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  const UserLockRelease = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "2");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "3");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "4");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "5");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "6");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "7");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "8");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "9");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "10");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "15");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "17");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "18");


    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };

  async function fetchSearchLog() {
    try {

      const searchList = await CustomerService.GetSearchLog("8");
      setRecentSearches(searchList);
    } catch (error) {
      console.error('Error fetching Roles:', error);
    }
  }
  useEffect(() => {
    fetchPurchaseOrder(ClientCompanyID, SupplierID, currentPage, pageSize);
    fetchSearchLog();
  }, [ClientCompanyID, SupplierID, currentPage, pageSize]);

  useEffect(() => {
    fetchPurchaseOrder(ClientCompanyID, SupplierID, currentPage, pageSize);
  }, [ClientCompanyID, SupplierID, sortConfig]);

  useEffect(() => {
    UserLockRelease();
    IsModuleAssigned();
    fetchParts();
    fetchSuppliers();
    fetchPurchaseOrder();
  }, [ClientCompanyID, SupplierID]);

  const handleCloseModal = async (isChanged) => {


    const closeModal = async () => {
      await PurchaseOrderService.UnLockPurchaseOrder(localStorage.getItem('PurchaseOrderID'));
      fetchPurchaseOrder(ClientCompanyID, SupplierID, "0", pageSize);
      setCurrentPage(1);
      setMultipleIds([]);
      setIsModalOpen(false);
    };

    if (isChanged != true) {
      closeModal();
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to close this record?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, close it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        closeModal();
      }
    });
  };

  const handleCloseSF = () => {
    setIsSFModalOpen(false);
    setCurrentPage(1);
    fetchPurchaseOrder(ClientCompanyID, SupplierID, "0", pageSize);
  };
  const handleCloseDeliveryModal = () => {
    fetchPurchaseOrder(ClientCompanyID, SupplierID, "0", pageSize);
    setshowPurchaseDeliveryModal(false);
  };
  const handleDeleteClick = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    if (multipleIds.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: `You are about to delete ${multipleIds.length} record(s). This cannot be undone!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await PurchaseOrderService.DeletePurchaseOrder(multipleIds);
            setMultipleIds([]);
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
              $(tableRef.current).DataTable().destroy();
            }
            fetchPurchaseOrder(ClientCompanyID, SupplierID, "0", pageSize);
            setSelectedId("0");
            Swal.fire(
              'Deleted!',
              'Your record has been deleted.',
              'success'
            );
          } catch (error) {
            console.error('Error deleting job:', error);
            Swal.fire(
              'Error!',
              'There was a problem deleting the record.',
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to delete purchase order.',
        'warning'
      );
    }
  };
  const handleCreatePurchaseOrderClick = () => {
    localStorage.setItem('PurchaseOrderID', "");
    localStorage.setItem('PurchaseOrderID', "0");
    localStorage.setItem('HasRecordUpdated', "0");
    setIsModalOpen(true);
  };
  const handleEditClick = async (ID) => {
    const IsAlreadyLeadID = localStorage.getItem('PurchaseOrderID');
    if (IsAlreadyLeadID) {
      await PurchaseOrderService.UnLockPurchaseOrder(IsAlreadyLeadID);
    }
    const poDetail = await fetchPurchaseOrderDetail(ID);
    if (poDetail) {
      localStorage.setItem('PurchaseOrderID', "");
      localStorage.setItem('PurchaseOrderID', ID);
      localStorage.setItem('HasRecordUpdated', "0");
      setSelectedId(ID);
      setIsModalOpen(true);

    }
  };
  const truncateText = (text, maxLength = 10) => {
    if (!text) return '';

    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;

  };
  const fetchPurchaseOrderDetail = async (PurchaseOrderID) => {
    try {
      const redirectCallback = () => navigate('/');

      if (PurchaseOrderID > 0) {
        const purchaseOrderDetail = await PurchaseOrderService.GetPurchaseOrderByID(redirectCallback, PurchaseOrderID);
        const purchaseOrder = purchaseOrderDetail[0];
        return purchaseOrder;
      }
    } catch (error) {
      console.error('Error fetching agreement details:', error);
    }
  };

  const { handleOrderPurchase } = useOrderPurchase(selectedId);
  const handleCreateOrderPurchase = async (event) => {
    event.stopPropagation();

    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (ID > 0) {
      const purchaseOrderDetail = await fetchPurchaseOrderDetail(ID);
      if (purchaseOrderDetail.bit_OnOrder === 1) {
        Swal.fire(
          '',
          'The Selected Purchase Order is already Ordered.',
          'Warning'
        );
      }
      else {
        Swal.fire({
          title: 'Are you sure?',
          text: "Create order from the selected Purchase order!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Order it!'
        }).then(async (result) => {
          if (result.isConfirmed) {
            const postData = await handleOrderPurchase(event, ID);
            if (postData === "Data saved successfully") {
              Swal.fire(
                '',
                'Purchase Order ordered Sucessfully.',
                'Success'
              );
              if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy();
              }
              await fetchPurchaseOrder(ClientCompanyID, SupplierID, "0", pageSize);
            }

          }
        });
      }
    }
    else {
      Swal.fire(
        '',
        'Please select a row to order.',
        'Warning'
      );
    }
  }

  const { handleDeliverPurchase } = DeliverPurchase(selectedId);
  const handleCreateDeliverPurchase = async (event) => {
    event.stopPropagation();
    let ID = 0;
    for (const id of multipleIds) {
      ID = id;
    }
    if (ID > 0) {

      const purchaseOrderDetail = await fetchPurchaseOrderDetail(ID);

      if (purchaseOrderDetail.bit_OnOrder === 0) {
        Swal.fire(
          '',
          'The Selected Purchase Order is not Ordered. Please order the Purchase order first',
          'Warning'
        );
      }
      else if (purchaseOrderDetail.snt_DeliveryStatus === 2) {
        Swal.fire(
          '',
          'The Selected Purchase Order is already delivered',
          'Warning'
        );
      }
      else {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, deliverd!'
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {

              setPartData([]);
              set_CustomerID(0);
              set_JobID(0);
              setshowPurchaseDeliveryModal(true);
              set_bnt_OrderNumber(purchaseOrderDetail.bnt_OrderNumber);
              set_CustomerID(purchaseOrderDetail.CustomerID !== null ? purchaseOrderDetail.CustomerID : 0);
              set_JobID(purchaseOrderDetail.FK_Issue_ID !== null ? purchaseOrderDetail.FK_Issue_ID : 0);
              set_PurchaseID(ID);

              const PurchaseOrderItemsList = await handleDeliverPurchase(event, selectedId);
              setPartData(PurchaseOrderItemsList);
              return
            } catch (error) {

              Swal.fire(
                'Error!',
                'There was a problem deleting the record.',
                'error'
              );
            }
          }
        });
      }
    }
    else {
      Swal.fire(
        '',
        'Please select a row to deliver.',
        'Warning'
      );
    }
  };
  const fetchSuppliers = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const data = await SupplierService.GetAllSuppliers(redirectCallback);
      setSupplierList(data);
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  const handleShortFallParts = async (event) => {
    event.stopPropagation();
    setIsSFModalOpen(true);
  };

  const handleCheckboxChange = (event, id) => {
    event.stopPropagation();
    setSelectedId((prevSelectedId) => (prevSelectedId === id ? "0" : id)); // Toggle selection
    setMultipleIds((prevSelectedIds) => {
      if (event.target.checked) {
        return [...prevSelectedIds, id];
      } else {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      }
    });
  };
  const handleSuccess = async () => {
    await fetchPurchaseOrder(ClientCompanyID, SupplierID, "0", pageSize);
    setshowPurchaseDeliveryModal(false);
  };
  const redirecttoUnAuthorzied = () => {
    navigate('/Unauthorized'); // Redirect to the login page
  };
  const IsModuleAssigned = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      const Modules = await ModuleService.GetModuleByClientID(CompanyID, "8");
      if (Modules.length === 0) {
        Swal.fire(
          'UnAuthorzied Access!',
          'Sorry, You are not authorized to access this module.',
          'warning'
        );
        redirecttoUnAuthorzied();
      }
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  const handlePageChange = (page) => {
    setPurchaseOrderData([]);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);

    }
  };
  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize(newPageSize);
    setPageSizeInCookie(newPageSize);
    setCurrentPage(1); // Reset to the first page
  };
  const handleSearchButtonClick = async () => {
    setCurrentPage(1); // Reset to first page
    setPurchaseOrderData([]); // Clear previous data
    const query = searchQuery.toLowerCase(); // Use current searchQuery state
    let columnsToSearch = searchColumns.length > 0
      ? searchColumns.join(",")
      : "ALL";
    setSearchOptions(columnsToSearch);
    const purchaseOrderData = await PurchaseOrderService.GetAllPurchaseOrders(redirectCallback, ClientCompanyID, SupplierID, currentPage, pageSize.toString(),
      query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), columnsToSearch.toString());
    setPurchaseOrderData(purchaseOrderData);

    const porderCount = await PurchaseOrderService.GetPurchaseOrderCount(redirectCallback, CustomerID, SupplierID, searchQuery, columnsToSearch.toString());
    setPOCount(porderCount[0].TotalRecords);
    setTotalPages(Math.ceil(porderCount[0].TotalRecords / pageSize)); // Set total pages dynamically

    const searchList = await CustomerService.GetSearchLog("8");
    setRecentSearches(searchList);
  };
  const handleSort = async (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const newConfig = { key, direction };
    setSortConfig(newConfig);
    setSortConfigInCookie(newConfig);
    setCurrentPage(1);

    setSortConfig({ key, direction });
    const porderData = await PurchaseOrderService.GetAllPurchaseOrders(redirectCallback, ClientCompanyID, SupplierID, "1", pageSize.toString(),
      searchQuery.toString(), key.toString(), direction.toString(), searchColumns.toString());

    const porderCount = await PurchaseOrderService.GetPurchaseOrderCount(redirectCallback, ClientCompanyID, SupplierID, searchQuery, searchColumns.toString());

    setPOCount(porderCount[0].TotalRecords);
    setPurchaseOrderData(porderData);

    setTotalPages(Math.ceil(porderCount[0].TotalRecords / pageSize));
  };

  const defaultColumns = [
    "PK_PurchaseOrder_ID",
    "dt_PurchaseOrderDate",
    "Pvc_SupplierName",
    "Pvc_SupplierInvoice",
    "PCompanyName",
    "PSiteName",
    "Pvc_User7",
    "Pon_order",
    "Pdelivered",
    "Pprinted",
    "Pposted",
    "PTotal",
    "Ppaid",
    "ModifiedBy",
  ];

  const columnOptions = [
    { value: "PK_PurchaseOrder_ID", label: "Order No" },
    { value: "dt_PurchaseOrderDate", label: "Order Date" },
    { value: "Pvc_SupplierName", label: "Supplier" },
    { value: "Pvc_SupplierInvoice", label: "Invoice No" },
    { value: "PCompanyName", label: "Customer" },
    { value: "PSiteName", label: "Site" },
    { value: "Pvc_User7", label: "Reference" },
    { value: "Pon_order", label: "On Order" },
    { value: "Pdelivered", label: "Delivered" },
    { value: "Pprinted", label: "Printed" },
    { value: "Pposted", label: "Posted" },
    { value: "PTotal", label: "Total" },
    { value: "Ppaid", label: "Paid" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "AssignTo", label: "AssignTo" },
    { value: "ModifiedBy", label: "ModifiedBy" }
  ];

  const getStoredColumns = () => {
    const storedColumns = Cookies.get(`PurchaseColumns_${CompanyID}`);
    return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
  };

  const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
  const handleColumnChange = (selectedOptions) => {
    setVisibleColumns(selectedOptions);

    // Save selection to cookies (valid for 1 year)
    Cookies.set(`PurchaseColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
  };
  const defaultColumnsForSearch = [
    "PK_PurchaseOrder_ID",
    "dt_PurchaseOrderDate",
    "Pvc_SupplierName",
    "Pvc_SupplierInvoice",
    "PCompanyName",
    "PSiteName",
    "Pvc_User7",
    "Pon_order",
    "Pdelivered",
    "Pprinted",
    "Pposted",
    "PTotal",
    "Ppaid",
    "ModifiedBy"
  ];
  const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
  const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
  const columnSearchOptions = [
    { value: "PK_PurchaseOrder_ID", label: "Order No" },
    { value: "dt_PurchaseOrderDate", label: "Order Date" },
    { value: "Pvc_SupplierName", label: "Supplier" },
    { value: "Pvc_SupplierInvoice", label: "Invoice No" },
    { value: "PCompanyName", label: "Customer" },
    { value: "PSiteName", label: "Site" },
    { value: "Pvc_User7", label: "Reference" },
    { value: "Pon_order", label: "On Order" },
    { value: "Pdelivered", label: "Delivered" },
    { value: "Pprinted", label: "Printed" },
    { value: "Pposted", label: "Posted" },
    { value: "PTotal", label: "Total" },
    { value: "Ppaid", label: "Paid" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "AssignTo", label: "Assign To" },
    { value: "ModifiedBy", label: "ModifiedBy" }

  ];
  const handleSearchColumnChange = (selectedOptions) => {
    setSearchColumns(selectedOptions);

  };

  const handleExportExcel = async () => {

    if (multipleIds.length === 0) {
      Swal.fire(
        'Warning!',
        'Please select at least one record to export.',
        'warning'
      );
      return;
    }
    setLoading(true);
    try {

      // Filter only selected customers
      const selectedJob = PurchaseOrderList.filter(job =>
        multipleIds.includes(job.PK_PurchaseOrder_ID)
      );

      if (!selectedJob || selectedJob.length === 0) {
        Swal.fire(
          'Warning!',
          'No selected data to export.',
          'warning'
        );
        return;
      }

      const headers = visibleColumns.map(col =>
        columnOptions.find(opt => opt.value === col)?.label || col
      );

      const rows = selectedJob.map(row =>
        visibleColumns.map(col => {
          let value = row[col];
          if (col === "PK_PurchaseOrder_ID") {
            value = `${row.bnt_OrderNumber ?? ""}`;
          }
          if (col === "dt_PurchaseOrderDate") {
            value = `${row.dt_PurchaseOrderDate ?? ""}`;
          }
          if (col === "Pvc_SupplierName") {
            value = `${row.vc_SupplierName ?? ""}`;
          }
          if (col === "Pvc_SupplierInvoice") {
            value = `${row.vc_SupplierInvoice ?? ""}`;
          }
          if (col === "Pvc_User7") {
            value = `${row.vc_User7 ?? ""}`;
          }
          if (col === "Pdelivered") {
            value = `${row.Delivered ?? ""}`;
          }
          if (col === "PTotal") {
            value = `${row.Total ?? ""}`;
          }
          return `"${(value ?? '').toString().replace(/"/g, '""')}"`;
        }).join(',')
      );

      const csvContent = [
        headers.join(','), // CSV Header
        ...rows            // CSV Rows
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Purchase Order.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error exporting selected customers:', error);
    } finally {
      setLoading(false);
    }
  };
  const [lastCheckedIndex, setLastCheckedIndex] = useState(null);

  // NEW: handle click (not change)
  const handleCheckboxClick = (event, id, index) => {
    event.stopPropagation();

    const isChecked = event.target.checked;

    if (event.shiftKey && lastCheckedIndex !== null) {
      const start = Math.min(lastCheckedIndex, index);
      const end = Math.max(lastCheckedIndex, index);
      const idsInRange = PurchaseOrderList.slice(start, end + 1).map(l => l.PK_PurchaseOrder_ID);

      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) {
          idsInRange.forEach(x => s.add(x));     // range select
        } else {
          idsInRange.forEach(x => s.delete(x));  // range unselect
        }
        return Array.from(s);
      });
    } else {
      // normal single toggle
      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) s.add(id); else s.delete(id);
        return Array.from(s);
      });
    }

    // Always update the anchor index
    setLastCheckedIndex(index);
  };


  const getInitialWidths = () => {
    const saved = Cookies.get(`PurchaseColumnWidths_${CompanyID}_${UserID}`);
    const defaults = {};

    visibleColumns.forEach(col => {
      defaults[col] = 110;
    });

    if (!saved) return defaults;

    const parsed = JSON.parse(saved);
    const applied = {};

    visibleColumns.forEach(col => {
      applied[col] = parsed[col] || 110;
    });

    return applied;
  };

  const [columnWidths, setColumnWidths] = useState(getInitialWidths);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const resizingColumn = useRef(null);
  const MIN_COL_WIDTH = 60;

  /**
   * Load widths from cookie when visibleColumns changes
   */
  useEffect(() => {
    const savedWidths = Cookies.get(`PurchaseColumnWidths_${CompanyID}_${UserID}`);
    if (savedWidths) {
      const parsed = JSON.parse(savedWidths);
      setColumnWidths((prev) => ({
        ...prev,
        ...parsed
      }));
    }
  }, [PurchaseOrderList]);


  /**
   * Start Column Resize
   */
  const startResize = (e, key) => {
    e.stopPropagation();
    startX.current = e.clientX;
    resizingColumn.current = key;

    const th = e.target.closest("th");   // FIXED HERE
    startWidth.current = th.offsetWidth;

    document.addEventListener("mousemove", resizeColumn);
    document.addEventListener("mouseup", stopResize);
  };

  /**
   * Resize Column dynamically
   */
  const resizeColumn = (e) => {
    if (!resizingColumn.current) return;

    const delta = e.clientX - startX.current;
    const newWidth = Math.max(startWidth.current + delta, MIN_COL_WIDTH);

    setColumnWidths(prev => ({
      ...prev,
      [resizingColumn.current]: newWidth
    }));
  };
  useEffect(() => {
    setColumnWidths(getInitialWidths());
  }, [visibleColumns]);

  /**
   * Stop resizing and save to cookie
   */
  const stopResize = () => {
    document.removeEventListener("mousemove", resizeColumn);
    document.removeEventListener("mouseup", stopResize);

    const key = resizingColumn.current;
    if (key) {
      setColumnWidths(prev => {
        // Save using the most recent updated state
        Cookies.set(
          `PurchaseColumnWidths_${CompanyID}_${UserID}`,
          JSON.stringify(prev),
          { expires: 365 }
        );
        return prev;
      });
    }

    resizingColumn.current = null;
  };


  /**
   * Auto-fit column width
   */
  const autoFitColumn = (key) => {
    const cells = document.querySelectorAll(`[data-col='${key}']`);
    let maxWidth = 0;

    cells.forEach(cell => {
      maxWidth = Math.max(maxWidth, cell.scrollWidth);
    });

    const newWidth = maxWidth + 20;

    const updated = { ...columnWidths, [key]: newWidth };

    setColumnWidths(updated);

    Cookies.set(
      `PurchaseColumnWidths_${CompanyID}_${UserID}`,
      JSON.stringify(updated),
      { expires: 365 }
    );
  };

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [reportTitle, setReportTitle] = useState('');
  const [reportLink, setReportLink] = useState('');
  const [inputValues, setInputValues] = useState({});
  const [outputData, setOutputData] = useState([]);
  const [error, setError] = useState(null);

  const getMergedPDFBytes = async (id) => {
    try {
      const currentInputValues = {
        ClientID: localStorage.getItem("CompanyID"),
        ID: id
      };

      const redirectCallback = () => navigate('/');

      let reportData = await ReportService.GetCompanyReports(redirectCallback, "8");
      reportData = reportData.filter(x => x.IsDefault.toString() === "1");

      const reportID = reportData.length > 0 ? reportData[0].ID : 118;
      const JasperReport = await JasperReportService.GetJasperReportByID(reportID);

      const queryObjMain = {
        ...currentInputValues,
        format: 'pdf',
        ReportName: JasperReport[0].ReportName,
        ReportType: JasperReport[0].ReportType,
        name: JasperReport[0].ReportName
      };

      const responseMain = await axiosInstance.get(
        `/Dashboard/ProxyReport?${new URLSearchParams(queryObjMain)}`,
        { responseType: 'blob' }
      );

      const mainPdfBytes = await responseMain.data.arrayBuffer();

      const pdfDoc = await PDFDocument.load(mainPdfBytes);

      return pdfDoc;

    } catch (err) {
      console.error(err);
      return null;
    }
  };
  const handlePrintUser = async (event) => {
    event.stopPropagation();


    setLoading(true);


    if (multipleIds.length > 0) {
      try {
        const finalMergedPdf = await PDFDocument.create();

        // ================= MERGE INVOICES =================
        for (const id of multipleIds) {

          const pdfDoc = await getMergedPDFBytes(id);

          if (!pdfDoc) continue;

          const pages = await finalMergedPdf.copyPages(
            pdfDoc,
            pdfDoc.getPageIndices()
          );

          pages.forEach(page => finalMergedPdf.addPage(page));
        }

        // ================= ADD TERMS ONLY ONCE =================


        // ================= FINAL OUTPUT =================
        const finalBytes = await finalMergedPdf.save();
        const finalBlob = new Blob([finalBytes], { type: "application/pdf" });

        const finalUrl = URL.createObjectURL(finalBlob);
        setLoading(false);
        setPdfUrl(finalUrl);
        setShowPdfModal(true);

      } catch (err) {
        console.error('Error executing report:', err);
        setError('Failed to execute the report.');
      }
    } else {
      Swal.fire(
        'Error!',
        'Please check at least one record to print job.',
        'warning'
      );
    }
  };

  const handleStart = (e, ui) => {
    e.stopPropagation();
  }
  return (

    <div>

      {ClientCompanyID === 0 && SupplierID === 0 && (

        <Common showAddButton={'yes'} handleAddTask={handleCreatePurchaseOrderClick}
          showReportButton={'none'} handleReports={null}
          showServiceJob={'none'} handleServiceJob={null}
          showSaleOrder={'none'} handleSaleOrder={null}
          showPurchaseOnOrder={'yes'} handlePurchaseOnOrder={handleCreateOrderPurchase}
          showPurchaseDelivery={'yes'} handlePurchaseOnOrderDelivery={handleCreateDeliverPurchase}
          showDeleteButton={'yes'} handleDeleteItem={handleDeleteClick}
          ModuleID={"8"} showShortFallParts={'yes'} handleShortFallParts={handleShortFallParts}
          showExportButton={'yes'} handleExportExcel={handleExportExcel}
          isDisabled={multipleIds.length > 1}
          showPrintUser={'yes'} handlePrintUser={handlePrintUser}
          HelpFormName="Purchasing List" HelpModule="9"
          RecordID={multipleIds}
        />

      )}
      {loading && (
        <div class="loading">
          <div class="d-table">
            <div class="d-tablecell">
              <span class="loader">
                <span class="loader-inner"></span>
              </span>
            </div>
          </div>
        </div>
      )}
      <div className="main-content-header">
        <div className="row">
          <div className="col-xl-2">
            <h1>{t("purchase_orders")}</h1>
          </div>


          <div className="col-xl-10 d-flex justify-content-end">
            <ColumnOptionDropDown
              options={columnOptions}
              selectedOptions={visibleColumns}
              onChange={handleColumnChange}
            />



          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card mb-30">
            <div className="card-body">

              <div className="table-responsive" style={{ overflow: "visible" }}>
                <div className="row mb-3">
                  <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>
                  <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                  <div className="col-sm-6"></div>
                  <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>

                    <MultiSearchDropDown
                      options={columnSearchOptions}
                      selectedOptions={searchColumns}
                      onChange={handleSearchColumnChange}
                    />
                  </div>
                  <div className="col-sm-2 d-flex justify-content-end">
                    <input
                      list="recent-searches"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="form-control me-2"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearchButtonClick();
                        }
                      }}
                    />
                    <datalist id="recent-searches">
                      {recentSearches.map((item, idx) => (
                        <option key={idx} value={item.SearchQuery} />
                      ))}
                    </datalist>
                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                      <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                  </div>



                </div>



                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                  <table
                    style={{
                      tableLayout: "fixed",
                      width: "max-content",
                      minWidth: "100%"
                    }}
                    className="table m-0 table-hover"
                    ref={tableRef}
                  >
                    <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                      <tr>
                        <th
                          className="checkbox-header"
                          style={{
                            width: "40px",
                            minWidth: "40px",
                            maxWidth: "40px",
                            position: "sticky",
                            left: 0,
                            zIndex: 5,

                          }}
                        ></th>
                        {visibleColumns.includes("PK_PurchaseOrder_ID") &&
                          <th onClick={() => handleSort('PK_PurchaseOrder_ID')}

                            style={{
                              width: `${columnWidths?.PK_PurchaseOrder_ID}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('order_no')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'PK_PurchaseOrder_ID'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "PK_PurchaseOrder_ID");
                              }}
                              onDoubleClick={() => autoFitColumn("PK_PurchaseOrder_ID")}
                            />

                          </th>
                        }
                        {visibleColumns.includes("dt_PurchaseOrderDate") &&
                          <th onClick={() => handleSort('dt_PurchaseOrderDate')}

                            style={{
                              width: `${columnWidths?.dt_PurchaseOrderDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('order_date')} <i
                              className={`ms-1 icofont ${sortConfig.key === 'dt_PurchaseOrderDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "dt_PurchaseOrderDate");
                              }}
                              onDoubleClick={() => autoFitColumn("dt_PurchaseOrderDate")}
                            /></th>
                        }
                        {visibleColumns.includes("Pvc_SupplierName") &&
                          <th onClick={() => handleSort('vc_SupplierName')}

                            style={{
                              width: `${columnWidths?.vc_SupplierName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('supplier')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_SupplierName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_SupplierName");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_SupplierName")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("Pvc_SupplierInvoice") &&
                          <th onClick={() => handleSort('vc_SupplierInvoice')}

                            style={{
                              width: `${columnWidths?.vc_SupplierInvoice}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('invoice_no')} <i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_SupplierInvoice'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_SupplierInvoice");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_SupplierInvoice")}
                            /></th>
                        }
                        {visibleColumns.includes("PCompanyName") &&
                          <th onClick={() => handleSort('CompanyName')}

                            style={{
                              width: `${columnWidths?.CompanyName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('customer')} <i
                              className={`ms-1 icofont ${sortConfig.key === 'CompanyName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "CompanyName");
                              }}
                              onDoubleClick={() => autoFitColumn("CompanyName")}
                            /></th>
                        }
                        {visibleColumns.includes("PSiteName") &&
                          <th onClick={() => handleSort('SiteName')}

                            style={{
                              width: `${columnWidths?.SiteName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Site<i
                              className={`ms-1 icofont ${sortConfig.key === 'SiteName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "SiteName");
                              }}
                              onDoubleClick={() => autoFitColumn("SiteName")}
                            /></th>
                        }
                        {visibleColumns.includes("Pvc_User7") &&
                          <th onClick={() => handleSort('vc_User7')}

                            style={{
                              width: `${columnWidths?.vc_User7}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('reference')} <i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_User7'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_User7");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_User7")}
                            /></th>
                        }
                        {visibleColumns.includes("Pon_order") && <th

                          style={{
                            width: `${columnWidths?.on_order}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('on_order')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "on_order");
                            }}
                            onDoubleClick={() => autoFitColumn("on_order")}
                          /></th>}
                        {visibleColumns.includes("Pdelivered") && <th

                          style={{
                            width: `${columnWidths?.delivered}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('delivered')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "delivered");
                            }}
                            onDoubleClick={() => autoFitColumn("delivered")}
                          /></th>}
                        {visibleColumns.includes("Pprinted") && <th

                          style={{
                            width: `${columnWidths?.printed}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('printed')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "printed");
                            }}
                            onDoubleClick={() => autoFitColumn("printed")}
                          /></th>}
                        {visibleColumns.includes("Pposted") && <th

                          style={{
                            width: `${columnWidths?.posted}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('posted')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "posted");
                            }}
                            onDoubleClick={() => autoFitColumn("posted")}
                          /></th>}
                        {visibleColumns.includes("PTotal") && <th onClick={() => handleSort('Total')}

                          style={{
                            width: `${columnWidths?.Total}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('total')}
                          <i
                            className={`ms-1 icofont ${sortConfig.key === 'Total'
                              ? sortConfig.direction === 'asc'
                                ? 'icofont-caret-up'
                                : 'icofont-caret-down'
                              : 'icofont-sorting'
                              }`}
                          ></i>
                        </th>
                        }

                        {visibleColumns.includes("Ppaid") && <th

                          style={{
                            width: `${columnWidths?.paid}px`,
                            minWidth: `${MIN_COL_WIDTH}px`
                          }}
                          className="resizable ellipsis">{t('paid')}<div
                            className="resize-handle"
                            onMouseDown={(e) => {
                              e.stopPropagation();   // STOP the click event from bubbling
                              startResize(e, "paid");
                            }}
                            onDoubleClick={() => autoFitColumn("paid")}
                          /></th>}
                        {visibleColumns.includes("AssignTo") &&
                          <th onClick={() => handleSort('AssignTo')}

                            style={{
                              width: `${columnWidths?.AssignTo}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Assign To
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'AssignTo'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "AssignTo");
                              }}
                              onDoubleClick={() => autoFitColumn("AssignTo")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("UpdatedDate") &&
                          <th onClick={() => handleSort('UpdatedDate')}

                            style={{
                              width: `${columnWidths?.UpdatedDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Last Action
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'UpdatedDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "UpdatedDate");
                              }}
                              onDoubleClick={() => autoFitColumn("UpdatedDate")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("ModifiedBy") &&
                          <th onClick={() => handleSort('ModifiedBy')}
                            style={{
                              width: `${columnWidths?.ModifiedBy}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Modified By
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'ModifiedBy'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "ModifiedBy");
                              }}
                              onDoubleClick={() => autoFitColumn("ModifiedBy")}
                            />
                          </th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {PurchaseOrderList.map((order, index) => (

                        <tr key={order.PK_PurchaseOrder_ID} onClick={() => handleEditClick(order.PK_PurchaseOrder_ID)}
                          style={{
                            backgroundColor: selectedId.toString() === order.PK_PurchaseOrder_ID.toString() ? 'rgb(197, 218, 237)' : '', // Highlight background
                            cursor: 'pointer',
                          }}>
                          <td
                            className="checkbox-cell"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              width: "40px",
                              minWidth: "40px",
                              maxWidth: "40px",
                              position: "sticky",
                              left: 0,
                              zIndex: 3,
                              backgroundColor:
                                selectedId.toString() === order.PK_PurchaseOrder_ID.toString()
                                  ? 'rgb(197, 218, 237)'
                                  : '#fff'
                            }}
                          >
                            <div
                              className="checkbox-hover-area"
                              onClick={(event) => handleCheckboxClick(event, order.PK_PurchaseOrder_ID, index)}
                            >
                              <input
                                type="checkbox"
                                checked={multipleIds.includes(order.PK_PurchaseOrder_ID)}
                                readOnly

                              />
                            </div>
                          </td>
                          {visibleColumns.includes("PK_PurchaseOrder_ID") && <td style={{
                            width: columnWidths.PK_PurchaseOrder_ID,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{order.bnt_OrderNumber}</td>}
                          {visibleColumns.includes("dt_PurchaseOrderDate") && <td style={{
                            width: columnWidths.dt_PurchaseOrderDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDate(order.dt_PurchaseOrderDate)}</td>}
                          {visibleColumns.includes("Pvc_SupplierName") && <td style={{
                            width: columnWidths.vc_SupplierName,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={order.vc_SupplierName}>{order.vc_SupplierName}</td>}
                          {visibleColumns.includes("Pvc_SupplierInvoice") && <td style={{
                            width: columnWidths.Pvc_SupplierInvoice,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{order.vc_SupplierInvoice}</td>}
                          {visibleColumns.includes("PCompanyName") &&
                            <td style={{
                              width: columnWidths.CompanyName,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis" title={order.CompanyName}>
                              {order.CompanyName != null && order.CompanyName !== "" && (
                                order.CompanyName
                              )}
                            </td>
                          }
                          {visibleColumns.includes("PSiteName") &&
                            <td style={{
                              width: columnWidths.SiteName,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis" title={order.SiteName}>
                              {order.SiteName != null && order.SiteName !== "" && (
                                order.SiteName
                              )}
                            </td>
                          }
                          {visibleColumns.includes("Pvc_User7") &&
                            <td style={{
                              width: columnWidths.vc_User7,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis" title={order.vc_User7}>
                              {order.vc_User7 != null && order.vc_User7 !== "" && (
                                order.vc_User7
                              )}
                            </td>
                          }
                          {visibleColumns.includes("Pon_order") &&
                            <td style={{
                              width: columnWidths.on_order,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis">
                              {order.bit_OnOrder === 1 && (
                                <img src='assets/img/resources/tick.png' style={{ width: "20px" }}></img>
                              )}
                            </td>
                          }
                          {visibleColumns.includes("Pdelivered") && <td >{order.Delivered}</td>}
                          {visibleColumns.includes("Pprinted") && <td ></td>}
                          {visibleColumns.includes("Pposted") && <td ></td>}
                          {visibleColumns.includes("PTotal") && <td >{order.BaseCurrency}{parseFloat(order.Total).toFixed(2)}</td>}
                          {visibleColumns.includes("Ppaid") && <td ></td>}
                          {visibleColumns.includes("AssignTo") && <td style={{
                            width: columnWidths.AssignTo,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {order.AssignTo ? (
                              <div
                                title={order.AssignTo}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {order.AssignTo.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}
                          {visibleColumns.includes("UpdatedDate") && <td style={{
                            width: columnWidths.UpdatedDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDateWithFns(order.UpdatedDate, activeDateFormat)}  </td>}
                          {visibleColumns.includes("ModifiedBy") && <td style={{
                            width: columnWidths.ModifiedBy,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {order.ModifiedBy ? (
                              <div
                                title={order.ModifiedBy}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#368938",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {order.ModifiedBy.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}
                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                      <tr>
                        <td colSpan={visibleColumns.length + 1}>
                          <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                            Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                            {/* Last Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(totalPages)} // Navigate to last page
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} /> Last
                            </button>

                            {/* Next Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} /> Next
                            </button>

                            <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                              Page {currentPage} of {totalPages}
                            </span>

                            {/* Previous Page Button */}
                            <button
                              style={{ float: "right", marginRight: "5px", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} /> Prev
                            </button>

                            {/* First Page Button */}
                            <button
                              style={{ float: "right" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(1)} // Navigate to first page
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} /> First
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>


                  {/* Page Size Selector */}


                </div>
                {(isModalOpen &&
                  <PurchaseOrderDetailModal PurchaseOrderID={localStorage.getItem('PurchaseOrderID')} onClose={handleCloseModal} onSuccess={fetchPurchaseOrder} />
                )}
                {showPurchaseDeliveryModal && bnt_OrderNumber &&
                  <PurchaseOrderDeliveryModal
                    show={showPurchaseDeliveryModal}
                    OnSuccess={handleSuccess}
                    onClose={handleCloseDeliveryModal}
                    parts={partList}
                    setParts={setPartData}
                    bnt_OrderNumber={bnt_OrderNumber}
                    purchaseID={purchaseID}
                    CustomerID={CustomerID}
                    jobID={jobID}
                  />
                }
                {isSFModalOpen &&
                  <ShortFallPartPage onClose={handleCloseSF} shorFallPartList={shorFallPartList} SupplierList={SupplierList} />
                }
                {showPdfModal && pdfUrl && (
                  <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                      <Draggable handle=".modal-content" onStart={handleStart}>
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">PDF Report</h5>
                            <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                              <span>&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                          </div>
                        </div>
                      </Draggable>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>




    </div>


  );
}
export default PurchaseOrderList;